<template>
  <div>
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);" title="消息中心" left-arrow @click-left="$router.back()" />
    <div style="height: 60px"></div>
    <div class="van-tabs-view van-tabs">
      <div class="van-tabs__wrap" style="margin: 0 15px">
        <div role="tablist" class="van-tabs__nav van-tabs__nav--card">
          <div role="tab" @click="changType(1)" aria-selected="true" :class="type == 1 ? 'van-tab van-tab--active' : 'van-tab'">
            <span class="van-tab__text van-tab__text--ellipsis">公告</span>
          </div>
          <div role="tab" @click="changType(2)" :class="type == 2 ? 'van-tab van-tab--active' : 'van-tab'">
            <span class="van-tab__text van-tab__text--ellipsis"><span>站内信</span></span>
          </div>
        </div>
      </div>
      <div class="van-tabs__content" style="width: 90%; margin: 0 auto; padding-top: 20px">
        <div v-if="type == 1" role="tabpanel" class="van-tab__pane" style="">
          <van-list class="notice-list" finished-text="没有更多了" :finished="true" v-if="homenoticelis.length > 0">
            <van-cell class="notice-cell" v-for="(item, index) in homenoticelis" :key="item.id || index">
              <div class="notice-title">{{ item.name || item.title || '公告' }}</div>
              <div class="notice-content" v-html="item.content || ''"></div>
            </van-cell>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">没有更多了~</van-divider>
        </div>
        <div v-if="type == 2" role="tabpanel" class="van-tab__pane">
          <van-list class="notice-list" finished-text="没有更多了" offset="300" v-model="loading" :finished="noticeList.length == noticeListInfo.total" @load="getDatalist" v-if="noticeList.length > 0">
            <van-cell class="notice-cell" v-for="(item, index) in noticeList" :key="item.id || index">
              <h3 class="unReadTitle">
                <span>{{ item.title || item.name || '站内信' }}</span>
              </h3>
              <div class="notice-content" v-html="item.content || ''"></div>
              <div class="notice-time" v-if="item.created_at">{{ item.created_at }}</div>
            </van-cell>
          </van-list>
          <van-divider v-else dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px 100px' }">没有更多了~</van-divider>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'message',
  data() {
    return { type: 1, noticeList: [], homenoticelis: [], noticeListInfo: {}, page: 1 };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type * 1;
    }

    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(type) {
      let that = this;
      that.type = type;
    },
    homenotice() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = Array.isArray(res.data) ? res.data : [];
        }
        that.$parent.hideLoading();
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      if (page > that.noticeListInfo.last_page) {
        that.loading = false;

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeListInfo = res.data;
            if (page == 1) {
              that.noticeList = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list4));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.noticeList = list;
            }
            that.page = page + 1;
          }
          that.loading = false;

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.notice-list {
  background: transparent;
}

.notice-cell {
  margin-bottom: 10px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(31, 45, 61, 0.06);
}

.notice-title,
.unReadTitle {
  margin: 0 0 8px;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}

.notice-content {
  color: #606f85;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
}

.notice-content ::v-deep p {
  margin: 0 0 6px;
}

.notice-content ::v-deep p:last-child {
  margin-bottom: 0;
}

.notice-time {
  margin-top: 8px;
  color: #9aa6b5;
  font-size: 12px;
  line-height: 18px;
}

.van-tabs__nav--card .van-tab.van-tab--active {
    color: #1989fa;
    background-color: #cf866b;
}
.van-tabs__nav--card {

    border: 1px solid #ffffff;
}
.van-tabs__nav--card .van-tab{
    color: #000;

}
.van-tabs__nav--card .van-tab{
  border-right: 0 solid #cf866b;
}
</style>



// WEBPACK FOOTER //
// src/components/message.vue